
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// import { useRouteError } from "react-router-dom";

export default function _404_() {
    const [lang, setLang] = useState("fr");
    const [title, setTitle] = useState("");
    const [message, setMessage] = useState("");
    const location = useLocation();
    
    const _titles = {
        "fr": "Nous n'avons rien trouver !",
        "en": "Not found!"
    }
    const _messages = {
        "fr": "Le contenu demandé n'exitse pas. <a>Retour</a>",
        "en": "The requested content is missing. <a>Go back</a>"
    }

    useEffect(() => {
        let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : 'fr';
        setMessage( _messages[_lang])
        setTitle( _titles[_lang])
    }, []);

    useEffect(() => {
        let _lang = location.hash ? location.hash.replace("#", "").toLocaleLowerCase() : 'fr';
        setMessage( _messages[_lang])
        setTitle( _titles[_lang])
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location])

    return (
        <div id="archive-project">
            <h2>{title}</h2>
            <p>{message}</p>
        </div>
    );
}